import { useTypedParams } from '@sorare/routing';

import { RequestLineupForm } from '@sorare/gameplay/src/components/noCardRoute/RequestLineupForm';
import { disclaimerMessages } from '@sorare/gameplay/src/lib/noCardRoute';

import type { PageParams } from './__generated__/routeParams';

const NoCardEntry = () => {
  const { so5FixtureId } = useTypedParams<PageParams>();

  return (
    <RequestLineupForm
      so5FixtureId={so5FixtureId}
      disclaimers={[
        disclaimerMessages.eligibilityCheck,
        disclaimerMessages.leaderboardSelection,
        disclaimerMessages.captain,
      ]}
    />
  );
};

export default NoCardEntry;
